import React, { ReactNode, SyntheticEvent, useState } from 'react';
import classNames from 'classnames';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { Button, Icon } from 'vetrf-ui';
import styles from '../../FormNestedBlock.module.scss';

type NestedBlockWithAccordionProps<T> = {
  title: ReactNode;
  fields?: T[];
  addBlock?: () => void;
  children: ReactNode;
  collapsedData?: ReactNode;
  collapsedDataAlwaysVisible?: boolean;
  isCollapsed?: boolean;
  compact?: boolean;
  maxBlockCount?: number;
  customBtns?: ReactNode;
  highlight?: boolean;
  withChildAccordions?: boolean;
};

export const NestedBlockWithAccordion = <T,>({
  title,
  children,
  fields,
  addBlock,
  collapsedData,
  collapsedDataAlwaysVisible,
  isCollapsed = false,
  compact = false,
  maxBlockCount,
  customBtns,
  highlight,
  withChildAccordions,
}: NestedBlockWithAccordionProps<T>) => {
  const [expanded, setExpanded] = useState(!isCollapsed);

  const handleChange = (e: SyntheticEvent) => {
    const el = e.target as HTMLElement;
    if (el.innerText === 'Добавить') {
      return;
    }
    setExpanded((prev) => !prev);
  };

  return (
    <Accordion
      className={classNames({
        [styles.parentBlock]: true,
        [styles.withChildAccordions]: withChildAccordions,
      })}
      expanded={expanded}
      onChange={handleChange}
    >
      <AccordionSummary
        className={classNames({
          [styles.parentBlockHeader]: true,
          [styles.parentBlockHeader_compact]: compact,
          [styles.highlight]: highlight,
        })}
        expandIcon={<Icon icon="chevron-up blue" className={styles.parentBlockHeaderIcon} />}
      >
        <div className={styles.parentBlockHeaderContent}>
          <h2 className={styles.parentBlockHeaderTitle}>{title}</h2>
          {!expanded && fields && <div className={styles.parentBlockCounter}>{fields.length}</div>}
          {addBlock && !(maxBlockCount && fields && fields.length >= maxBlockCount) && (
            <div className={styles.parentBlockButton}>
              <Button
                disabled={!expanded}
                color="info"
                icon="plus"
                iconColor="white"
                iconSize={100}
                size="xs"
                onClick={addBlock}
                text="Добавить"
              />
            </div>
          )}
          {customBtns && <div className={styles.parentBlockButton}>{customBtns!}</div>}
        </div>
        {(!expanded || collapsedDataAlwaysVisible) && collapsedData && (
          <div className={styles.parentBlockCollapsedData}>{collapsedData}</div>
        )}
      </AccordionSummary>
      <AccordionDetails className={styles.parentBlockBody}>{children}</AccordionDetails>
    </Accordion>
  );
};
